'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.queries = undefined;

var _cardDetails = require('./cardDetails/mx/cardDetails');

var _cardDetails2 = require('./cardDetails/fr/cardDetails');

var _cardDetails3 = require('./cardDetails/jp/cardDetails');

var _cardDetails4 = require('./cardDetails/it/cardDetails');

var _cardDetails5 = require('./cardDetails/de/cardDetails');

var _mx = require('./compare/mx');

var _fr = require('./compare/fr');

var _jp = require('./compare/jp');

var _it = require('./compare/it');

var _de = require('./compare/de');

var _vac = require('./viewAllCards/mx/vac');

var _vac2 = require('./viewAllCards/fr/vac');

var _vac3 = require('./viewAllCards/jp/vac');

var _vac4 = require('./viewAllCards/it/vac');

var _vac5 = require('./viewAllCards/de/vac');

// compare
var queries = exports.queries = {
  cardDetails: {
    fr: _cardDetails2.query,
    jp: _cardDetails3.query,
    mx: _cardDetails.query,
    it: _cardDetails4.query,
    de: _cardDetails5.query,
    defaultCountry: _cardDetails.query
  },
  compare: {
    fr: _fr.query,
    jp: _jp.query,
    mx: _mx.query,
    it: _it.query,
    de: _de.query,
    defaultCountry: _mx.query
  },
  viewAllCards: {
    fr: _vac2.query,
    jp: _vac3.query,
    mx: _vac.query,
    it: _vac4.query,
    de: _vac5.query,
    defaultCountry: _vac.query
  }
};
// viewAllCards
// cardDetails